import React from 'react';
import { Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import union20 from '../../../Assets/union20.png';
import { CloseButton,Content, ImageContainer, Line, ModalContent, StyledModal } from './PopupError.styles';



const PopupError = ({ open, onClose , Title, SubTitle , ContentBody}) => {
    return (
        <StyledModal open={open} onClose={onClose}>
            <ModalContent>
                <ImageContainer>
                    <img src={union20} alt="Bulls" /> 
                    <CloseButton onClick={onClose}>
                        <CloseIcon />
                    </CloseButton>
                </ImageContainer>
                <Line />
                <Content>
                    <Typography variant="h6" component="h2" sx={{fontWeight:"700"}}>
                        {Title || ""}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ marginTop: 5, fontWeight:"600" ,fontSize:"14px"}}>
                        {SubTitle || ""}
                    </Typography>
                    <Typography variant="body2" component="p" sx={{ marginTop: 3,fontSize:"14px" }}>
                        {ContentBody || ""}
                    </Typography>
                    <Typography variant="body2" component="p" sx={{ marginTop: 3 ,fontSize:"14px"}}>
                        Go to '<a href="/dashboard">Homepage</a>'
                    </Typography>
                </Content>
            </ModalContent>
        </StyledModal>
    );
};

export default PopupError;
